"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbSignatureKey = void 0;
const repository_1 = require("../../../features/authoriser/infra/repositories/verifySignatureKey/repository");
class MbSignatureKey {
    constructor(api, data, url) {
        this.api = api;
        this.progressId = data.progressId;
        this.data = data;
        this.url = url;
    }
    doVerify(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const verificationData = {
                signatureKey: value,
                signatureKeyPositions: this.data.signatureKeyPositions,
            };
            return repository_1.verifySignatureKeyChallengeRepository.verify(this.api, this.progressId, verificationData, this.url.verify);
        });
    }
}
exports.MbSignatureKey = MbSignatureKey;
//# sourceMappingURL=signatureKey.js.map